<template>
  <FormPage
    title="Новый водитель"
    description="Создайте водителя-исполнителя. Поля ФИО, паспорт, водительское обязательны."
  >
    <template #controls>
    </template>
    <DriverForm @sendForm="onSubmit" @closeForm="onCancel" />
  </FormPage>
</template>

<script>
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { createToaster } from '@meforma/vue-toaster'
import DriverForm from '@/components/forms/DriverForm.vue'

const toaster = createToaster()

export default {
  name: 'DriverCreatePage',
  components: { DriverForm },
  setup() {
    const router = useRouter()
    const store = useStore()

    const onSubmit = async ({ model, form }) => {
      const created = await store.dispatch('apiStorage/addItem', { model, form })
      if (!created) return
      toaster.success('Водитель добавлен')
      const id = created.id
      if (id != null) {
        router.push({ name: 'DriverDetail', params: { id: String(id) } })
      } else {
        router.push({ name: 'Driver' })
      }
    }

    const onCancel = () => {
      router.push({ name: 'Driver' })
    }

    return { onSubmit, onCancel }
  },
}
</script>
